import React from 'react';

const FloatingButton = () => {
  const handleClick = () => {
    // Navigate to https://cssgenerators.vercel.app/
    window.location.href = 'https://cssgenerators.vercel.app/';
  };

  return (
    <div className="floating-button">
      <button onClick={handleClick} className="focus:outline-none">
        <span className="text-white text-lg">🌐</span>
      </button>
      <div className="tooltip">
        CssGenerators
      </div>
    </div>
  );
};

export default FloatingButton;
